<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import setup from "../setupComposable/setup";
import commonProps from "../props/commonProps";

defineProps(commonProps);
const emit = defineEmits(["update:modelValue"]);
const { onInput } = setup(emit);
</script>

<template>
  <div>
    <label v-if="$attrs.label" :class="{ required: $attrs.required }">
      {{ $attrs.label }}
    </label>
    <input
      class="form-control"
      :type="type"
      :value="modelValue"
      v-bind="$attrs"
      @input="onInput"
    />
  </div>
</template>
